// extracted by mini-css-extract-plugin
export default {"productCarousel":"h4-z"};